import ArticlePage from "@/pages/article/ArticlePage";

export default function BestHoodiesSweaters() {
  return <ArticlePage slug="best-hoodies-sweaters-vigorbuy-spreadsheet" />;
}